import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import MKBox from "./MKBox";
import MKButton from "./MKButton";
import { Typography, Modal, Stack, CircularProgress } from "@mui/material";
import API_BASE_URL from "../apiConfig";

function ClubPortalModal({ open, onClose, adminClubIds, onEditClub }) {
  const [clubDetails, setClubDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch club details when modal opens
  useEffect(() => {
    if (open && adminClubIds.length > 0) {
      setLoading(true);
      const fetchClubDetails = async () => {
        try {
          const clubPromises = adminClubIds.map(clubId => 
            fetch(`${API_BASE_URL}/api/clubs/${clubId}`, { credentials: 'include' })
              .then(res => res.json())
          );
          
          const clubs = await Promise.all(clubPromises);
          setClubDetails(clubs);
        } catch (error) {
          console.error('Error fetching club details:', error);
        } finally {
          setLoading(false);
        }
      };
      
      fetchClubDetails();
    }
  }, [open, adminClubIds]);

  return (
    <Modal open={open} onClose={onClose}>
      <MKBox
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Club Portal
        </Typography>
        {adminClubIds.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            You are not an admin or owner of any clubs.
          </Typography>
        ) : loading ? (
          <MKBox sx={{ textAlign: 'center', py: 4 }}>
            <CircularProgress />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Loading club details...
            </Typography>
          </MKBox>
        ) : (
          <Stack spacing={2}>
            {clubDetails.map((club) => (
              <MKBox key={club.id} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2, border: "1px solid #eee", borderRadius: 1 }}>
                <div>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {club.name}
                  </Typography>
                </div>
                <MKButton size="small" onClick={() => onEditClub(club.id)}>
                  Edit
                </MKButton>
              </MKBox>
            ))}
          </Stack>
        )}
        <MKButton onClick={onClose} variant="outlined" sx={{ mt: 3, width: "100%" }}>
          Close
        </MKButton>
      </MKBox>
    </Modal>
  );
}

ClubPortalModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  adminClubIds: PropTypes.array.isRequired,
  onEditClub: PropTypes.func.isRequired,
};

export default ClubPortalModal; 